<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Usuário">
        <input class="form-input" v-model="config.auth.user">
      </form-group>
      <form-group label="Senha">
        <input class="form-input" v-model="config.auth.password">
      </form-group>
    </div>

    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
      </div>
      <form-group label="Enviar informação de prazo extra">
        <label class="form-switch">
          <input type="checkbox" v-model="config.product.forwardCrossDocking">
          <span class="form-switch__indicator"></span>
        </label>
        <small class="form-help">Define se a informação de prazo extra dos produtos será sincronizada com o marketplace.</small>
      </form-group>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <div class="l-col-6@md">
          <quotation-configuration :quotation="config.quotation" :marketplace="identifier"/>
        </div>
      </div>
    </panel>

    <panel title="Vendedor">
      <div class="l-row">
        <form-group label="Tipo padrão">
          <select v-model="config.seller.type" class="form-select">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option value="1P">1P</option>
            <option value="3P">3P</option>
          </select>
        </form-group>

        <form-group label="Nome padrão">
          <input class="form-input" v-model="config.seller.name">
        </form-group>
      </div>
    </panel>
    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
    </panel>


    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados no Zoom.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados no Zoom.</small>
        </form-group>

      </div>
    </panel>

  </module-configuration>
</template>

<script>
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'zoom'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'zoom',
      config: {
        auth: {
          environment: 'sandbox',
          user: null,
          password: null
        },
        product: {
          forwardCrossDocking: false,
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null
        },
        quotation: {
          shipmentMethod: null
        },
        seller: {
          type: null,
          name: null
        },
        synchronize: {
          stock: true,
          price: true
        }
      },
      synchronizeOptions: [
        true,
        false
      ]
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      },
      'config.quotation.shipmentMethod' (value) {
        this.isPreferenceRequired = value !== null
      }
    },
    computed: {
      preferences () {
        return [
          'lowestPrice',
          'shorterTime'
        ]
      }
    },
    components: {
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration,
      OrderRetrieveDateConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Zoom.vue?8f78b8cc